/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/forbid-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Loader from '../../../loader';
import WarningBox from './warning-box';
import { eventRegExp, registrationFormTestRegExp }
  from '../../../../../editor-context-provider/components/editor-windows/constants';

import LocalizationConsumer from '../../../../l10n/localization-context';

const urlToEventId = (url) =>
{
  const eventId = (url.match(eventRegExp) || [])[1];
  return parseInt(eventId, 10) || null;
};

class EventTab extends React.Component
{
  static propTypes =
  {
    url: PropTypes.string.isRequired,
    onComponentMount: PropTypes.func.isRequired,
    onEventClick: PropTypes.func.isRequired,
    setRegistratonFormOption: PropTypes.func.isRequired,
    eventsData: PropTypes.array,
    isEventsDataLoading: PropTypes.bool.isRequired,
    isEventsDataLoadingError: PropTypes.bool.isRequired,
    isSlideShowInsertLinksMode: PropTypes.bool.isRequired
  };

  static defaultProps = {
    eventsData: null
  };

  constructor(props)
  {
    super(props);

    const { setRegistratonFormOption, url } = props;

    setRegistratonFormOption(registrationFormTestRegExp.test(url));
  }

  state = {
    selectedEventId: null,
    isAdminOnlyEventSelected: false,
    isLimitedEventSelected: false
  };

  componentDidMount()
  {
    this.props.onComponentMount();
  }

  onEventItemClick = (event) =>
  {
    const { onEventClick } = this.props;

    const { id, accessControl } = event;

    const { adminOnly, limited } = accessControl.permissions;

    this.setState({
      selectedEventId: id,
      isAdminOnlyEventSelected: adminOnly,
      isLimitedEventSelected: limited
    });

    onEventClick(event);
  };

  renderEvent = (event) =>
  {
    const { selectedEventId } = this.state;
    const { url: propsUrl } = this.props;

    const {
      id,
      title,
      startDate,
      accessControl,
      isEventPassed
    } = event;

    const { adminOnly, limited } = accessControl.permissions;

    const itemClassNames = classnames({
      '-wa-edit-controls__event-item': true,
      '-wa-edit-controls__event-item__passed': isEventPassed
    });

    const accessControlIconClassNames = classnames({
      '-wa-edit-controls__events-link-access-control': true,
      '-wa-edit-controls__events-link-access-control__admin-only': adminOnly,
      '-wa-edit-controls__events-link-access-control__limited': limited
    });

    const accessControlLinkClassNames = classnames({
      '-wa-edit-controls__event-link': true,
      '-wa-edit-controls__event-link__selected': id === selectedEventId || id === urlToEventId(propsUrl),
      '-wa-edit-controls__event-link__past': isEventPassed
    });

    return (
      <li className={itemClassNames} key={id}>
        <div className="-wa-edit-controls__event-date">{startDate}</div>
        <a href="#" className={accessControlLinkClassNames} onClick={() => this.onEventItemClick(event)}>
          <span className="-wa-edit-controls__event-title" title={title}>{title}</span>
          <div className={accessControlIconClassNames} />
        </a>
      </li>
    );
  };

  renderEvents = (events) =>
  {
    if (!events.length) return null;

    return (
      <ul className="-wa-edit-controls__events-list">
        { events.map(event => this.renderEvent(event))}
      </ul>
    );
  };


  renderContent = (data) =>
  {
    const upcomingEvents = data.filter(event => event.isEventPassed === false);
    const pastEvents = data.filter(event => event.isEventPassed === true);
    const emptyStateLabel = data.length ? null :
    <LocalizationConsumer id="insert-link-dialog.events-tab.no-events-label" />;

    const { isSlideShowInsertLinksMode } = this.props;
    const { isAdminOnlyEventSelected, isLimitedEventSelected } = this.state;

    const getEventsStructureHeight = () =>
    {
      const isAdminOnlyOrLimited = isAdminOnlyEventSelected || isLimitedEventSelected;

      if (isSlideShowInsertLinksMode)
      {
        return isAdminOnlyOrLimited ? '222px' : '265px';
      }
      return isAdminOnlyOrLimited ? '392px' : '435px';
    };

    const getWarning = () =>
    {
      if (isAdminOnlyEventSelected)
      {
        return <LocalizationConsumer id="insert-link-dialog.events-tab.admin-only-event-warning" />;
      }
      if (isLimitedEventSelected)
      {
        return <LocalizationConsumer id="insert-link-dialog.events-tab.restricted-event-warning" />;
      }
      return null;
    };

    return (
      <div className="-wa-edit-controls__events-tab">
        <div className="-wa-edit-controls__events-structure" style={{ height: getEventsStructureHeight() }}>
          {emptyStateLabel}
          {upcomingEvents.length ? (
            <div className="-wa-edit-controls__pages-structure-header">
              <LocalizationConsumer id="insert-link-dialog.events-tab.upcoming-events" />
            </div>) : null}
          {this.renderEvents(upcomingEvents)}
          {pastEvents.length ? (
            <div className="-wa-edit-controls__pages-structure-header">
              <LocalizationConsumer id="insert-link-dialog.events-tab.past-events" />
            </div>) : null}
          {this.renderEvents(pastEvents)}
        </div>
        <WarningBox>
          {getWarning()}
        </WarningBox>
      </div>
    );
  };

  render()
  {
    const { eventsData, isEventsDataLoading, isEventsDataLoadingError } = this.props;

    if (isEventsDataLoading)
    {
      return <Loader />;
    }

    if (isEventsDataLoadingError || !eventsData)
    {
      return (
        <div>
          <LocalizationConsumer id="insert-link-dialog.events-tab.load-error" />
        </div>
      );
    }

    return this.renderContent(eventsData);
  }
}

export default EventTab;